module.exports = __webpack_public_path__ + "img/画板 16.b49086be.jpg";